import * as React from 'react';
import { LocalForm } from 'react-redux-form';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { Link } from 'react-router-dom';

export interface RenewalChoiceComponentProperties {
  readonly saveCallback: (redirectURL: string) => void;
  readonly pastDueServiceFeeTotal: number;
  readonly contractId: number;
}

export class RenewalChoiceComponent extends React.Component<RenewalChoiceComponentProperties> {
  render() {
    return (
      <>
        <LocalForm model="renewalChoiceForm" hideNativeErrors={true}>
          {this.props.pastDueServiceFeeTotal ? (
            <h3>There is currently an outstanding balance of ${this.props.pastDueServiceFeeTotal} on this contract.</h3>
          ) : (
            ''
          )}
          <div className="row">
            <div className="col-md-4 text-right">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  this.props.saveCallback(RouteDefinitions.renewal.NoChanges);
                }}
              >
                Renew As Is
              </button>
            </div>
            <div className="col-md-4 text-center">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  this.props.saveCallback(RouteDefinitions.renewal.WithChanges);
                }}
              >
                Renew With Changes
              </button>
            </div>
            <div className="col-md-4 text-left">
              <Link
                to={getRoute(RouteDefinitions.contract.RenewalOptions, { id: this.props.contractId })}
                target="_blank"
              >
                <button className="btn btn-primary" type="button">
                  Renewal Options
                </button>
              </Link>
            </div>
          </div>
        </LocalForm>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/renewal/_components/renewal-choice.component.tsx